module.exports = __webpack_public_path__ + "static/media/csm-muti-parking-selected.b3c104b9.svg";